import { combineReducers, configureStore } from '@reduxjs/toolkit';
import adminSlice from './slices/adminSlice';
import locationSlice from './slices/locationSlice';
import googleBusinessSlice from './slices/googleBusinessSlice';
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// import { ConfigProvider } from 'antd';

const persistConfig = {
  key: 'hotel',
  storage,
};

const rootReducer = combineReducers({
  admin: adminSlice,
  location: locationSlice,
  googleBusiness: googleBusinessSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

// export type RootState = {
//   admin: AdminState;
//   location: LocationState;
//   googleBusiness: GoogleBusinessState;
// };
// export type AppDispatch = typeof store.dispatch;
